import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

type IconType = "cards" | "credits" | "dice" | "howto";

function getIconFilename(icon: IconType) {
  switch (icon) {
    case "cards":
      return "Cards.png";
    case "credits":
      return "Credits.png";
    case "dice":
      return "Dice.png";
    case "howto":
      return "How to Use _.png";
  }
}

const Container = styled(Link)<{ noBackground?: boolean }>`
  display: block;
  width: calc(65 * var(--u));
  height: calc(65 * var(--u) * 259 / 1512);
  background: ${({ noBackground }) =>
    noBackground ? "none" : 'url("/assets/ui/home/Plaque.png")'};
  background-size: cover;
  background-repeat: no-repeat;
  margin: calc(2 * var(--u)) auto;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;

const FlexContainer = styled.span`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Icon = styled.span<{ icon: IconType }>`
  display: block;
  height: 100%;
  aspect-ratio: 1;
  background: url("/assets/ui/home/${({ icon }) => getIconFilename(icon)}");
  background-size: contain;
  background-repeat: no-repeat;
`;

const Label = styled.span`
  text-align: center;
  flex-grow: 1;
  color: white;
  font-family: "StencilStd", cursive;
  font-size: calc(5 * var(--u));
  margin-top: calc(2 * var(--u));
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
`;

export function BigButton(props: {
  label: string;
  icon: IconType;
  to: string;
  style?: CSSProperties;
  noBackground?: boolean;
  mode?: "button" | "title";
  onClick?: () => void;
}) {
  return (
    <Container
      noBackground={props.noBackground}
      to={props.to}
      onClick={props.onClick}
      style={props.style}
    >
      <FlexContainer>
        <Icon icon={props.icon} />
        <Label>{props.label}</Label>
      </FlexContainer>
    </Container>
  );
}
